import {apiUrl} from "js/app-configuration";

export const uploadDashboardBackgroundImage = (file) =>
  new Promise((resolve, reject) => {
    window.superagent
      .post(apiUrl + "/ApplicationLayer/dashboards/backgrounds/upload")
      .withCredentials()
      .attach("file", file)
      .end((error, response) => {
        if (error || !response || !response.body || !response.body.url) {
          reject(error || new Error("Upload failed"));
        } else {
          resolve(response.body.url);
        }
      });
  });
